import { render } from "./TaskDetails.vue?vue&type=template&id=4f1e159c&scoped=true"
import script from "./TaskDetails.vue?vue&type=script&lang=js"
export * from "./TaskDetails.vue?vue&type=script&lang=js"

import "./TaskDetails.vue?vue&type=style&index=0&id=4f1e159c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4f1e159c"

export default script